module.exports = __webpack_public_path__ + "static/guns-germs-and-steel-38b04a958ab65dbf9f8b812c4136000b.webp";